import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {}

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-fallback" className="flex min-h-[40vh] flex-col items-center justify-center gap-3 p-8 text-center">
          <p className="text-lg font-semibold text-[#0A0A0A]">Something went wrong.</p>
          <button
            data-testid="error-boundary-reload-button"
            onClick={() => window.location.reload()}
            className="rounded-sm border border-black/10 bg-[#0A0A0A] px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-black"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
